import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './add-on-get-app-qrcode.component.scss';
var AddOnGetAppQrcode = /** @class */ (function (_super) {
    tslib_1.__extends(AddOnGetAppQrcode, _super);
    function AddOnGetAppQrcode(element) {
        return _super.call(this, element) || this;
    }
    AddOnGetAppQrcode.prototype.init = function () {
    };
    AddOnGetAppQrcode.prototype.bindEvents = function () {
    };
    return AddOnGetAppQrcode;
}(Base));
export { AddOnGetAppQrcode };



//////////////////
// WEBPACK FOOTER
// ./components/add-on-get-app-qrcode/add-on-get-app-qrcode.component.ts
// module id = 602
// module chunks = 0